<template>
  <div>
    <CardedSectionHeader
      icon="mdi-dot"
      label="Slides Preview"
      id="admin_slides_list_preview"
    ></CardedSectionHeader>
    <Slider
        :items="items"
        :model_control="model_control"
        @on-click="clicked_slide"
    >
    </Slider>
    <CardedSectionHeader
      icon="mdi-dot"
      label="Slide's List Table"
      id="admin_slides_list_table"
    ></CardedSectionHeader>
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon> view
        </v-btn>
        <v-btn @click="on_edit_item(item)" x-small rounded text color="warning">
          <v-icon>mdi-pen</v-icon> edit
        </v-btn>
        <v-btn @click="on_delete_item(item)" x-small rounded text color="error">
          <v-icon>mdi-trash-can</v-icon> delete
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import Slider from "../../../components/Slider";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminSlidersList",
  components: {
    CardedTable,
    CardedSectionHeader,
    Slider
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      items: [],
      headers: [
        {
          text: "Position",
          align: "start",
          sortable: true,
          value: "position",
          filterable: true,
        },
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Page",
          align: "start",
          sortable: true,
          value: "page",
          filterable: true,
        },
        {
          text: "URL",
          align: "start",
          sortable: false,
          value: "click_url",
          filterable: false,
        },
        { text: "", value: "actions", sortable: false },
      ],
      model_control: -1
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Sliders.get_sliders(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading sliders on admin list", errors);
        }
      );
    },
    on_view_item(selected_item) {
      //look for the model
      var new_model = 0;
      for (var index = 0; index < this.items.length; index++) {
        var item = this.items[index];
        if (parseInt(item.id) == parseInt(selected_item.id)) {
          new_model = index;
          break;
        }
      }
      this.model_control = new_model;
      this.scroll_to_secton("admin_slides_list_preview");
    },
    on_edit_item(item) {
      this.$router.push("/admin/sliders/list/edit/" + item.id);
    },
    on_delete_item(item) {
      this.$router.push("/admin/sliders/list/delete/" + item.id);
    },
    scroll_to_secton(lmnt_id) {
      try {
        var options = {
          offset: 50,
          duration: 1000,
          easing: "easeInOutCubic",
        };
        this.$vuetify.goTo("#" + lmnt_id, options);
      } catch (error) {
        console.log(
          "Error scrolling to section on sliders page ",
          error,
          lmnt_id
        );
      }
    },
    clicked_slide(slide){
        if(slide.click_url.length == 0){
            alert("This slide does not navigate");
        }else{
            alert("This slide navigates to: " + slide.click_url);
        }
    }
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Sliders List",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Sliders",
          disabled: false,
          href: "/admin/sliders",
        },
        {
          text: "List",
          disabled: true,
          href: "/admin/sliders/list",
        },
      ],
    });
    this.load_items();
    this.scroll_to_secton("admin_slides_list_table");
  },
};
</script>